<div style="padding: 20px 0px; margin-top: 20px">
  @if (!contentEdit) {
    <h3>{{ item?.headline }}</h3>
  }
  @if (contentEdit) {
    <h3
      #heading
      [contentEditable]="contentEdit"
      [textContent]="$safeNavigationMigration(item?.headline)"
      (input)="item.headline = heading.textContent"></h3>
  }

  <div class="mod-image-quote mod-image-quote--light mod-image-quote--left mod-image-quote--background">
    <div
      class="m-content"
      style="padding: 20px 0px 30px 0px">
      <div class="m-text-content">
        @if (!contentEdit) {
          <p
            class="m-quote blockquote"
            [innerHTML]="$safeNavigationMigration(item?.text)"></p>
        }
        @if (contentEdit) {
          <coin-html-editor
            [item]="$any(item)"
            [contentEdit]="true"
            [isNews]="true"></coin-html-editor>
        }
        <!-- <p class="m-quote blockquote" *ngIf="contentEdit" [contentEditable]="contentEdit" [textContent]="item.text" (input)="item.text = $event.target.textContent"></p> -->
      </div>
    </div>
  </div>
</div>
